<template>
  <div class="tab_container">
    <!-- 本月洞见/总结 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        本月洞见/总结
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('conclusion')"
          >保存</el-button
        >
      </div>
    </div>
    <conclusion ref="conclusion" />
    <!-- 进销存及销售、订单计划 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        进销存及销售、订单计划
      </div>
    </div>
    <!-- 每月实销 -->
    <div class="second_title">
      每月实销
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('monthlySale')"
        >保存</el-button
      >
    </div>
    <monthly-sale ref="monthlySale" />
    <!-- 实销总结 -->
    <div class="second_title">
      实销总结
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('saleSummary')"
        >保存</el-button
      >
    </div>
    <sale-summary ref="saleSummary" />
    <!-- 每月进销存 -->
    <div class="second_title">
      每月进销存
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('monthlyPurchaseSaleStock')"
        >保存</el-button
      >
    </div>
    <monthly-purchase-sale-stock ref="monthlyPurchaseSaleStock" />
    <!-- 进销存推演总结 -->
    <div class="second_title">
      进销存推演总结
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('purchaseSaleStockSummary')"
        >保存</el-button
      >
    </div>
    <purchase-sale-stock-summary ref="purchaseSaleStockSummary" />
    <!-- 资金计划 -->
    <div class="second_title">
      资金计划
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('fundPlan')"
        >保存</el-button
      >
    </div>
    <fund-plan ref="fundPlan" />
    <!-- 渠道、售后数量及质量评价 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        渠道、售后数量及质量评价
      </div>
    </div>
    <!-- 渠道建设计划 -->
    <div class="second_title">
      渠道建设计划
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('channelConstructionPlan')"
        >保存</el-button
      >
    </div>
    <channel-construction-plan ref="channelConstructionPlan" />
    <!-- 渠道能力评估 -->
    <div class="second_title">
      渠道能力评估
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('channelAbilityEvaluation')"
        >保存</el-button
      >
    </div>
    <channel-ability-evaluation ref="channelAbilityEvaluation" />
    <!-- 售后服务 -->
    <div class="second_title">
      售后服务
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('saleAfterService')"
        >保存</el-button
      >
    </div>
    <sale-after-service ref="saleAfterService" />
    <!-- 产品销售政策及价格竞争力 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        产品销售政策及价格竞争力
      </div>
    </div>
    <!-- 产品销售政策 -->
    <div class="second_title">
      产品销售政策
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('productSalePolicy')"
        >保存</el-button
      >
    </div>
    <product-sale-policy ref="productSalePolicy" @setId="setId" />
    <!-- 价格竞争力 -->
    <div class="second_title">
      价格竞争力
      <el-button
        size="mini"
        type="primary"
        class="title_btn"
        @click="handleSave('priceCompete')"
        >保存</el-button
      >
    </div>
    <price-compete ref="priceCompete" @setId="setId" />
    <!-- 品牌建设及促销活动 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        品牌建设及促销活动
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('brandActivity')"
          >保存</el-button
        >
      </div>
    </div>
    <brand-activity ref="brandActivity" @setId="setId" />
    <!-- 资金能力及风险评价 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        资金能力及风险评价
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('fundEvaluation')"
          >保存</el-button
        >
      </div>
    </div>
    <fund-evaluation ref="fundEvaluation" @setId="setId" />
    <!-- 投资人意愿评价 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        投资人意愿评价
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('investorEvaluation')"
          >保存</el-button
        >
      </div>
    </div>
    <investor-evaluation ref="investorEvaluation" />
    <!-- 团队能力综合评价 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        团队能力综合评价
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('teamEvaluation')"
          >保存</el-button
        >
      </div>
    </div>
    <team-evaluation ref="teamEvaluation" @setId="setId" />
    <!-- 战略契合度综合评价 -->
    <div class="hearder_title">
      <div class="flex_between">
        <img class="title_icon" src="@/assets/img/title-icon.svg" alt="dark" />
        战略契合度综合评价
        <el-button
          size="mini"
          type="primary"
          class="title_btn"
          @click="handleSave('strategyEvaluation')"
          >保存</el-button
        >
      </div>
    </div>
    <strategy-evaluation ref="strategyEvaluation" @setId="setId" />
  </div>
</template>

<script>
import Conclusion from "./conclusion.vue";
import MonthlySale from "./monthlySale.vue";
import SaleSummary from "./saleSummary.vue";
import MonthlyPurchaseSaleStock from "./monthlyPurchaseSaleStock.vue";
import PurchaseSaleStockSummary from "./purchaseSaleStockSummary.vue";
import FundPlan from "./fundPlan.vue";
import ChannelConstructionPlan from "./channelConstructionPlan.vue";
import ChannelAbilityEvaluation from "./channelAbilityEvaluation.vue";
import SaleAfterService from "./saleAfterService.vue";
import ProductSalePolicy from "./productSalePolicy.vue";
import PriceCompete from "./priceCompete.vue";
import BrandActivity from "./brandActivity.vue";
import FundEvaluation from "./fundEvaluation.vue";
import InvestorEvaluation from "./investorEvaluation.vue";
import TeamEvaluation from "./teamEvaluation.vue";
import StrategyEvaluation from "./strategyEvaluation.vue";
import { getLookCustomerApi } from "@/api/saleTaskCollection";

export default {
  components: {
    Conclusion,
    MonthlySale,
    SaleSummary,
    MonthlyPurchaseSaleStock,
    PurchaseSaleStockSummary,
    FundPlan,
    ChannelConstructionPlan,
    ChannelAbilityEvaluation,
    SaleAfterService,
    ProductSalePolicy,
    PriceCompete,
    BrandActivity,
    FundEvaluation,
    TeamEvaluation,
    StrategyEvaluation,
    InvestorEvaluation
  },
  data() {
    return {};
  },
  methods: {
    async init(showDataObj) {
      await this.getLookCustomer(showDataObj.queryParams);
    },
    // 获取看差距
    async getLookCustomer(queryParams = {}) {
      try {
        let data = {};
        const res = await getLookCustomerApi({
          ...queryParams
        });
        if (res.status == 0) {
          data = res.data || {};
        } else {
          this.$DonMessage.error(res.message);
        }
        this.$refs.conclusion.init(data.saleSummary, queryParams);
        this.$refs.monthlySale.init(data.customerSaleList, queryParams);
        this.$refs.saleSummary.init(data.saleSummarySale, queryParams);
        this.$refs.monthlyPurchaseSaleStock.init(
          data.customerJxcList,
          queryParams
        );
        this.$refs.purchaseSaleStockSummary.init(
          data.saleSummaryJxcty,
          queryParams
        );
        this.$refs.fundPlan.init(data.customerMoneyPlanList, queryParams);
        this.$refs.channelConstructionPlan.init(
          data.customerChannelPlanList,
          queryParams
        );
        this.$refs.channelAbilityEvaluation.init(data.channelList, queryParams);
        this.$refs.saleAfterService.init(
          data.customerAfterSaleList,
          queryParams
        );
        this.$refs.productSalePolicy.init(
          data.customerPolicyPrice,
          queryParams
        );
        this.$refs.priceCompete.init(data.customerPolicyPrice, queryParams);
        this.$refs.brandActivity.init(data.customerPolicyPrice, queryParams);
        this.$refs.fundEvaluation.init(data.customerPolicyPrice, queryParams);
        this.$refs.investorEvaluation.init(
          data.customerInvestmentEvaluationList,
          queryParams
        );
        this.$refs.teamEvaluation.init(data.customerPolicyPrice, queryParams);
        this.$refs.strategyEvaluation.init(
          data.customerPolicyPrice,
          queryParams
        );
        this.$emit(
          "updateTime",
          "lookCustomerTabTime",
          this.getClosestDate([
            data.saleSummary?.updateTime,
            data.customerSaleList[0]?.updateTime,
            data.saleSummarySale?.updateTime,
            data.customerJxcList[0]?.updateTime,
            data.customerMoneyPlanList[0]?.updateTime,
            data.customerChannelPlanList[0]?.updateTime,
            data.channelList[0]?.updateTime,
            data.customerAfterSaleList[0]?.updateTime,
            data.customerPolicyPrice?.updateTime,
            data.customerInvestmentEvaluationList[0]?.updateTime
          ])
        );
      } catch (error) {}
    },
    // 获取最近的日期
    getClosestDate(dates) {
      if (dates.length === 0) return null; // 如果没有日期，返回null
      dates.sort((a, b) => a - b); // 按时间顺序排序
      return dates[0] || ""; // 取第一个元素，即最早的日期
    },
    // 保存
    handleSave(refField) {
      this.$refs[refField].handleSave(() => {
        this.$emit("updateTime");
      });
    },
    setId(id) {
      this.$refs.productSalePolicy.form.id = id;
      this.$refs.priceCompete.form.id = id;
      this.$refs.brandActivity.form.id = id;
      this.$refs.fundEvaluation.form.id = id;
      this.$refs.teamEvaluation.form.id = id;
      this.$refs.strategyEvaluation.form.id = id;
    }
  }
};
</script>

<style lang="scss" scoped>
.tab_container {
  padding-bottom: 20px;
  .hearder_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    color: #333333;
    padding: 14px 10px 14px 20px;
    border-bottom: 1px solid #dcdee0;
    .title_icon {
      margin-right: 10px;
    }
    p {
      font-size: 16px;
      color: #4095e5;
      font-weight: bold;
      i {
        font-size: 18px;
        color: #4095e5;
        display: inline-block;
        margin-right: 5px;
      }
    }
  }
  .second_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 22px 10px 10px 62px;
    border-bottom: 1px solid #dcdee0;
  }
  .third_title {
    display: flex;
    align-items: center;
    font-size: 14px;
    color: #1890ff;
    padding: 10px 10px 10px 62px;
  }
  .second_title + .third_title {
    padding-top: 25px;
  }
  .title_btn {
    margin-left: 20px;
  }
}
</style>
